export const isDesktop = () => {
	let width = window.innerWidth;
	if (width >= 960) {
		return true;
	} else return false;
};
